import React from 'react';
import { PRODUCTS } from '../../products';
import { useCart } from '../../context/CartContext';

export function PackCard({ pack }) {
  const { addItem } = useCart();

  const firstProd = PRODUCTS.find((p) => p.id === pack.contents[0].productId);

  return (
    <div className={`pack-card pack-${pack.type}`}>
      {pack.badge.includes('%')
        ? <span className="discount-side-banner">{pack.badge}</span>
        : <span className="pack-badge">{pack.badge}</span>
      }
      <div className="pack-icons">
        {pack.contents.map((c) => {
          const prod = PRODUCTS.find((p) => p.id === c.productId);
          return (
            <div className="pack-icon-item" key={c.productId}>
              <img src={prod.image} alt={prod.name} className="pack-thumb" loading="lazy" />
            </div>
          );
        })}
      </div>
      <h3 className="pack-name">{pack.name}</h3>
      <p className="pack-desc">{pack.description}</p>
      <div className="pack-pricing">
        <span className="pack-original">₹{pack.originalPrice}</span>
        <span className="pack-price">₹{pack.price}</span>
      </div>
      <button
        className="btn-primary btn-sm btn-cart"
        onClick={() => addItem({ id: pack.id, name: pack.name, price: pack.price, image: firstProd?.image || '/logo.webp' })}
      >
        🛒 Add to Cart
      </button>
    </div>
  );
}
